import Ws from '@adonisjs/websocket-client';
import { getToken, getEmpresaAtiva } from './auth';

function getSocketProtocol() {
	return window.location.hostname === 'localhost' ? 'ws://' : 'wss://';
}

export class SocketConnection {

	isConnected = false

	connect() {

		/* Realiza a conexão com o Socket da MovingPay */
		this.ws = Ws(`${getSocketProtocol()}${process.env.REACT_APP_SOCKET_IP}`, {
			reconnection: true,
			query: {
				customers_id: getEmpresaAtiva()
			}
		})
			.withApiToken(getToken())
			.connect();

		/* Caso a conexão seja bem sucedida */
		this.ws.on('open', ws => {
			this.isConnected = true;
		});

		/* Caso ocorra a desconexão do Socket da MovingPay */
		if (this.ws) {
			this.ws.on('close', () => {
				this.isConnected = false;
			});
		}

		return this;
	}

	subscribe(channel, handler) {

		/* Verifica a conexão com o socket */
		if (!this.ws) {
			/* Configura a conexão para desconectado */
			this.isConnected = false;

			/* Em caso de erro reconecta */
			this.connect();

			/* Aguarda 2 segundos para tentar reenviar */
			setTimeout(() => this.subscribe(channel), 2000);

			this.isConnected = true;
		}

		if (this.ws) {
			/* Verifica se está cadastrado no canal */
			var cadastroCanal = this.ws.getSubscription(channel);
			if (!cadastroCanal) {
				cadastroCanal = this.ws.subscribe(channel);
			}

			/* Em caso de recebimento de mensagem */
			cadastroCanal.on('message', message => {
				this.isConnected && handler && handler(message);
			});

			/* Em caso de erro */
			cadastroCanal.on('error', error => { });

			return cadastroCanal;
		}
	}

	disconnect() {
		if (this.ws) {
			this.ws.close()
			this.isConnected = false
		};
	}
}

export default new SocketConnection();
